import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';


const Read = () => {
  useEffect(() => {
    getData();
  }, []);
  const [data, setData] = useState([]);
  const [erro, setErr] = useState("");
  const [success, setSuccess] = useState("");
  async function getData() {
    try{
      // console.log(data.length);
      const response = await fetch("https://blogapp1-p9km.onrender.com/all");
      const result = await response.json();
      if(response.ok){
        setData(result);
        setErr("");
      }
      if(!response.ok){
        setData([]);
        setErr(result.error)
      }
    }catch(err){
       setErr(err)
    }
  }

  async function handleDelete(id){
    try{
      const response = await fetch(`https://blogapp1-p9km.onrender.com/${id}`,{
      method:"DELETE"});
        const result = await response.json();
        // console.log(result.name);
        setSuccess(`${result.name} Deleted Succesfully`);
        getData();
      }catch(err){
        setSuccess('');
    }
  }
  return (
    <div className='container'>
       <h1 className='text-center'>Your Blogs</h1>
        <hr />
      <div className="row justify-content-center">
      {success && <div className="alert alert-danger text-center" role="alert">{success}</div>}
        {
          (data.length>0)?data.map((ele) => {
            return <>
              <div key={ele._id} className="card text-center m-2" style={{ width: "18rem" }}>
                <div className="card-body">
                  <h5 className="card-title">{ele.name}</h5>
                  <h6 className="card-subtitle mb-2 text-muted">{ele.email}</h6>
                  <p className="card-text">{ele.age}</p>
                  <Link to={`/${ele._id}`}  className="card-link">Edit</Link>
                  <a href="#" onClick={()=>handleDelete(ele._id)} className="card-link">Delete</a>
                </div>
              </div>   
              </>
          }):<div className="c"><div class="custom-loader"></div></div>
        }
      </div>
    </div>
  )
}

export default Read
